var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegendDeilenk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7,
    y1: 171.5,
    x2: 7,
    y2: 1.5,
    gradientTransform: "translate(0 172) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e50031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e71945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ea325a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ec4c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ef6683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f27f98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f499ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f7b2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f9ccd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fce5ea"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.5.5H.5v170h13V.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendDeilenk);
export default __webpack_public_path__ + "static/media/legend_deilenk.fb4c12af2e149626e5c85a05dc26611e.svg";
export { ForwardRef as ReactComponent };